import {
  BuildingInformationResObj,
  GetBuildingItemReqParams
} from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class BuildingItemGateway {
  /** 業者ヒアリング-物件取得 */
  static getBuildingInformationResObj = async (
    params: GetBuildingItemReqParams
  ) => {
    const {
      simulationYm,
      procurementNo,
      subNo,
      branchCd,
      expenseCd,
      expenseSeq,
      supplierCd,
      supplierBranchCd
    } = params
    return await yamadumiApi.get<BuildingInformationResObj>(
      '/api/supplier/building/item',
      {
        simulationYm,
        procurementNo,
        subNo,
        branchCd,
        expenseCd,
        expenseSeq,
        supplierCd,
        supplierBranchCd
      }
    )
  }
}
